if (typeof window.quickShopManager === 'undefined') {
    class QuickShopManager {
        constructor() {
            this.cartCache = new Map();
            this.isAddingToCart = false;
            this.isOpeningCart = false;
            this.init();
        }
    
        init() {
            this.setupGlobalPatches();
            this.bindEvents();
            this.protectHeader();
            this.setupHeightSync();
        }
    
        setupGlobalPatches() {
            try {
                const globalScript = window.getFocusableElements || window.Shopify?.theme?.getFocusableElements;
    
                if (typeof globalScript === 'function') {
                    window.getFocusableElements = function (container) {
                        if (!container) {
                            return [];
                        }
                        return container.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
                    };
                }
            } catch (e) {
            }
        }
    
        bindEvents() {
            document.addEventListener('DOMContentLoaded', () => this.initializeQuickShop());
            document.addEventListener('shopify:section:load', () => {
                setTimeout(() => this.initializeQuickShop(), 100);
            });
            document.addEventListener('shopify:theme:load', () => {
                setTimeout(() => this.initializeQuickShop(), 100);
            });
            document.addEventListener('product-recommendations:loaded', () => {
                setTimeout(() => this.initializeQuickShop(), 100);
            });
            
            this.setupMutationObserver();
        }
    
        setupMutationObserver() {
            const observer = new MutationObserver((mutations) => {
                let hasNewCards = false;
                
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) {
                            if (node.classList?.contains('card__actions--addtobag') || 
                                node.querySelector?.('.card__actions--addtobag')) {
                                hasNewCards = true;
                            }
                        }
                    });
                });
                
                if (hasNewCards) {
                    setTimeout(() => {
                        this.initializeQuickShop();
                        this.syncWrapperHeights();
                    }, 200);
                }
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    
        setupHeightSync() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.syncWrapperHeights());
            } else {
                this.syncWrapperHeights();
            }
    
            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => this.syncWrapperHeights(), 150);
            });
    
            window.addEventListener('load', () => {
                setTimeout(() => this.syncWrapperHeights(), 100);
            });
        }
    
        syncWrapperHeights() {
            try {
                const wrappers = document.querySelectorAll('.card__actions--addtobag-wrapper');
                
                wrappers.forEach(wrapper => {
                    if (wrapper.closest('product-recommendations')) {
                        return;
                    }
    
                    const card = wrapper.closest('.card-wrapper, .product-card-wrapper');
                    if (!card) return;
    
                    const cardMedia = card.querySelector('.card__media');
                    if (!cardMedia) return;
    
                    const mediaHeight = cardMedia.offsetHeight;
                    
                    if (mediaHeight > 0) {
                        wrapper.style.height = `${mediaHeight}px`;
                    }
                });
            } catch (error) {
                console.error(error);
            }
        }
    
        protectHeader() {
            try {
                const headerElements = [
                    '.section-header',
                    '.header-wrapper',
                    '.header',
                    '.shopify-section-group-header-group'
                ];
    
                headerElements.forEach(selector => {
                    const element = document.querySelector(selector);
                    if (element) {
                        element.style.display = '';
                        element.style.visibility = '';
                        element.classList.remove('hidden');
                        
                        if (element.style.display === 'none') {
                            element.style.display = '';
                        }
                        if (element.style.visibility === 'hidden') {
                            element.style.visibility = '';
                        }
                    }
                });
    
                const body = document.body;
                if (body) {
                    const classesToRemove = ['header-hidden', 'hide-header'];
                    classesToRemove.forEach(className => {
                        if (body.classList.contains(className)) {
                            body.classList.remove(className);
                        }
                    });
                }
            } catch (error) {
                console.error(error);
            }
        }
    
        closeOtherCards(currentCard) {
            const cards = document.querySelectorAll('.card__actions--addtobag');
            cards.forEach(card => {
                if (card !== currentCard) {
                    const button = card.querySelector('.card__actions-button');
                    const variants = card.querySelector('.card__variants');
                    if (button && variants) {
                        button.classList.remove('hidden');
                        variants.classList.add('hidden');
                    }
                }
            });
        }
    
        waitForCartToRender(maxAttempts = 15) {
            return new Promise((resolve, reject) => {
                let attempts = 0;
    
                const check = () => {
                    attempts++;
                    const cartDrawer = document.querySelector('cart-drawer');
    
                    if (
                        cartDrawer &&
                        cartDrawer.querySelector('.cart-items') &&
                        cartDrawer.querySelector('.cart-items').children.length > 0
                    ) {
                        resolve();
                    } else if (attempts >= maxAttempts) {
                        reject('Cart drawer não renderizou a tempo');
                    } else {
                        setTimeout(check, 300);
                    }
                };
    
                check();
            });
        }
    
        waitForCartDrawer(maxAttempts = 15) {
            return new Promise((resolve, reject) => {
                let attempts = 0;
    
                const checkCartDrawer = () => {
                    attempts++;
                    const cartDrawer = document.querySelector('cart-drawer');
    
                    if (
                        cartDrawer &&
                        typeof cartDrawer.open === 'function' &&
                        cartDrawer.isConnected &&
                        cartDrawer.offsetHeight >= 0
                    ) {
                        resolve(cartDrawer);
                    } else if (attempts >= maxAttempts) {
                        reject(new Error('Cart drawer não encontrado'));
                    } else {
                        setTimeout(checkCartDrawer, 400);
                    }
                };
    
                checkCartDrawer();
            });
        }
    
        async forceCartUpdate() {
            try {
                const response = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`);
                if (response.ok) {
                    const html = await response.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newCartDrawer = doc.querySelector('#CartDrawer');
                    const currentCartDrawer = document.querySelector('#CartDrawer');
                    if (newCartDrawer && currentCartDrawer) {
                        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
                    }
    
                    const cartIconResponse = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-icon-bubble`);
                    if (cartIconResponse.ok) {
                        const cartIconHtml = await cartIconResponse.text();
                        const cartIconDoc = parser.parseFromString(cartIconHtml, 'text/html');
                        const newCartIcon = cartIconDoc.querySelector('#cart-icon-bubble');
                        const currentCartIcon = document.querySelector('#cart-icon-bubble');
                        if (newCartIcon && currentCartIcon) {
                            currentCartIcon.innerHTML = newCartIcon.innerHTML;
                        }
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    
        async openCartDrawer() {
            if (this.isOpeningCart) {
                return;
            }
    
            try {
                this.isOpeningCart = true;
                const cartDrawer = await this.waitForCartDrawer();
    
                await this.waitForCartToRender();
                cartDrawer.open();
            } catch (error) {
                try {
                    const fallback = document.querySelector('#cart-icon-bubble, .cart-icon, [data-cart-toggle]');
                    if (fallback) fallback.click();
                } catch (fallbackError) {
                }
            } finally {
                this.isOpeningCart = false;
            }
        }
    
        async handleSingleVariantForm(form, button) {
            if (this.isAddingToCart) {
                return;
            }
    
            try {
                const variantIdInput = form.querySelector('.product-variant-id');
                const variantId = variantIdInput ? variantIdInput.value : null;
    
                if (!variantId) {
                    throw new Error('Variant ID não encontrado');
                }
    
                await this.addToCart(variantId, button);
    
            } catch (error) {
                console.error(error);
            }
        }
    
        async addToCart(variantId, button) {
            if (this.isAddingToCart) {
                return;
            }
    
            try {
                this.isAddingToCart = true;
                this.protectHeader();
    
                const id = parseInt(variantId);
                if (!id || isNaN(id)) throw new Error(`ID inválido: ${variantId}`);
    
                let cartWasEmpty = false;
                try {
                    const cartRes = await fetch('/cart.js');
                    const cartJson = await cartRes.json();
                    cartWasEmpty = cartJson.item_count === 0;
                } catch (e) {
                }
    
                const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
                const config = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id, quantity: 1 })
                };
    
                if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
                    try {
                        const sections = cartDrawer.getSectionsToRender();
                        if (sections && sections.length > 0) {
                            const formData = new FormData();
                            formData.append('id', id);
                            formData.append('quantity', 1);
                            formData.append('sections', sections.map(s => s.id));
                            formData.append('sections_url', window.location.pathname);
                            config.body = formData;
                            config.headers = {};
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
    
                const response = await fetch('/cart/add.js', config);
                if (!response.ok) throw new Error(`Erro HTTP ${response.status}`);
    
                const data = await response.json();
                this.cartCache.set('lastUpdate', Date.now());
    
                if (cartDrawer) {
                    if (cartWasEmpty) {
                        await this.forceCartUpdate();
    
                        if (cartDrawer.classList.contains('is-empty')) {
                            cartDrawer.classList.remove('is-empty');
                        }
    
                        const drawerInner = cartDrawer.querySelector('.drawer__inner');
                        if (drawerInner && drawerInner.classList.contains('is-empty')) {
                            drawerInner.classList.remove('is-empty');
                        }
    
                        const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
                        if (cartDrawerItems && cartDrawerItems.classList.contains('is-empty')) {
                            cartDrawerItems.classList.remove('is-empty');
                        }
                    }
    
                    if (typeof cartDrawer.renderContents === 'function') {
                        await cartDrawer.renderContents(data);
                    } else if (typeof cartDrawer.refresh === 'function') {
                        await cartDrawer.refresh();
                    }
    
                    await this.waitForCartToRender();
                    requestAnimationFrame(() => {
                        cartDrawer.open();
                    });
                }
    
                await this.openCartDrawer();
    
                const cartIcon = document.querySelector('#cart-icon-bubble');
                if (cartIcon) {
                    try {
                        const cartResponse = await fetch('/cart.js');
                        const cartData = await cartResponse.json();
                        const cartCount = cartIcon.querySelector('.cart-count-bubble');
                        if (cartCount) {
                            cartCount.textContent = cartData.item_count;
                            if (cartData.item_count > 0) {
                                cartCount.style.display = 'flex';
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
    
                this.protectHeader();
    
            } catch (err) {
            } finally {
                this.isAddingToCart = false;
                this.protectHeader();
            }
        }
    
        initializeQuickShop() {
            try {
                const cards = document.querySelectorAll('.card__actions--addtobag');
    
                if (cards.length === 0) {
                    setTimeout(() => {
                        const retryCards = document.querySelectorAll('.card__actions--addtobag');
                        if (retryCards.length > 0) {
                            this.initCards(retryCards);
                            this.syncWrapperHeights();
                        }
                    }, 1000);
                    return;
                }
    
                this.initCards(cards);
                setTimeout(() => this.syncWrapperHeights(), 100);
            } catch (error) {
                console.error(error);
            }
        }
    
        initCards(cards) {
            cards.forEach((card, index) => {
                try {
                    if (card.closest('product-recommendations')) {
                        return;
                    }
    
                    const button = card.querySelector('.card__actions-button');
                    const variants = card.querySelector('.card__variants');
    
                    if (!button) {
                        return;
                    }
    
                    if (button._quickShopHandler) {
                        button.removeEventListener('click', button._quickShopHandler);
                    }
    
                    button._quickShopHandler = (e) => {
                        if (button.classList.contains('card__single-add-button')) {
                            e.preventDefault();
                            const form = button.closest('.card__single-add-form');
                            if (form) {
                                this.handleSingleVariantForm(form, button);
                            }
                        } else if (variants) {
                            this.closeOtherCards(card);
                            button.classList.add('hidden');
                            variants.classList.remove('hidden');
                        }
                    };
                    button.addEventListener('click', button._quickShopHandler);
    
                    if (variants) {
                        if (variants._quickShopHandler) {
                            variants.removeEventListener('click', variants._quickShopHandler);
                        }
    
                        variants._quickShopHandler = (e) => {
                            if (e.target === variants) {
                                variants.classList.add('hidden');
                                button.classList.remove('hidden');
                            }
                        };
                        variants.addEventListener('click', variants._quickShopHandler);
                    }
    
                    if (variants) {
                        const variantButtons = variants.querySelectorAll('.card__variant-item--available');
    
                        variantButtons.forEach((variantButton, variantIndex) => {
                            if (variantButton._quickShopHandler) {
                                variantButton.removeEventListener('click', variantButton._quickShopHandler);
                            }
    
                            variantButton._quickShopHandler = (e) => {
                                e.stopPropagation();
                                const variantId = variantButton.dataset.variantId;
                                if (variantId) this.addToCart(variantId, variantButton);
                            };
                            variantButton.addEventListener('click', variantButton._quickShopHandler);
                        });
                    }
    
                } catch (error) {
                }
            });
        }
    }
    
    window.quickShopManager = new QuickShopManager();
}
